import { SharedDirectivesModule, SharedFormModule } from '@agingplan';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbCollapseModule, NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingGalleryComponent } from './loading-gallery/loading-gallery.component';
import { LoadingComponent } from './loading/loading.component';
import { OneSidePageComponent } from './one-side-page/one-side-page.component';
import { TableComponent } from './table/table.component';

@NgModule({
  declarations: [LoadingGalleryComponent, LoadingComponent, TableComponent, OneSidePageComponent],
  exports: [LoadingGalleryComponent, LoadingComponent, TableComponent, OneSidePageComponent],
  imports: [CommonModule, RouterModule, NgbNavModule, NgbCollapseModule, NgbModalModule, SharedFormModule, SharedDirectivesModule],
  providers: [NgbActiveModal],
})
export class ComponentsModule {}
